$(window).on('load', function () {
    var optionSelectors = $(document).find("select.single-option-selector");
    var variant_selector = $(document).find("select.product-form__variants");
    var add_to_cart = $(document).find("#addToCartBtn");
    let img_galary = $(document).find(".product-detail .product-detail__showcase .carousel-cell img");
    optionSelectors.each(function () {
        var singleOptionSelector = $(this);
        singleOptionSelector.on("change", function () {
            var values = [];
            var variant = "";
            var value = getOptionValues(optionSelectors, values);
            for (var i = 0; i < value.length; i++) {
                if (i == 0) {
                    variant = value[i];
                } else {
                    variant = variant + " / " + value[i];
                }
            }
            // console.log(value);
            changeVariant(variant, variant_selector);
        })
    });

    function getOptionValues(optionSelectors, values) {
        $.each(optionSelectors, function () {
            values.push($(this).find('option:selected').val());
        });
        return values;
    }

    function changeVariant(variant, variant_selector) {
        // console.log(variant);
        variant_selector.find('option').each(function () {
            text = $(this).text().replace('  - Sold', '').trim();
            if (text == variant) {
                if ($(this).text().indexOf('Sold') >= 0) {
                    add_to_cart.addClass('disabled');
                } else {
                    add_to_cart.removeClass('disabled');
                }
                value = $(this).val();
                // console.log(text);
                if (typeof (value) != 'undefined') {
                    $(this).attr('selected', true);
                }

            } else {
                $(this).attr('selected', false);
            }

        });
        if (typeof (value) != 'undefined') {
            variant_selector.trigger('change').val(value);
            let options = variant_selector.find("option");
            for (let index = 0; index < options.length; index++) {
                const option = options.eq(index);
                if (option.val() == value) {
                    option.attr('selected', true);
                    let var_img_src = option.attr("data-img-url");
                    for (let j = 0; j < img_galary.length; j++) {
                        const element = img_galary.eq(j);
                        let img_src = element.attr('data-src');
                        if (var_img_src.includes(img_src)) {
                            // let top = element.offset().top;
                            $('html, body').animate({
                                scrollTop: $(element).offset().top - 0
                            }, 200);
                        }
                    }
                } else {
                    option.attr('selected', false);
                }
            }
        }
        let var_qty = variant_selector.find('option:selected').data('qty');
        let input = $('input[name="quantity"]');
        input.attr('max', var_qty).val(1);
        if (parseInt(var_qty) > 1) {
            $('.btn-number[data-type="plus"]').prop("disabled", false);
        }
        if ((variant_selector.find('option:selected').text()).indexOf("Sold out") > -1) {
            $(document).find("button#addToCartBtn").attr("disabled", true);
            $(document).find("button.shopify-payment-button__button").attr("disabled", true);
            // console.log("added disable");
        } else {
            $(document).find("button#addToCartBtn").attr("disabled", false);
            $(document).find("button.shopify-payment-button__button").attr("disabled", false);
            // console.log("removed disable");
        }
    }
    var card_swatches = $(document).find('.product-card-swatch li');
    card_swatches.on('click', function () {
        card_swatches.removeClass('active')
        $(this).addClass('active');
        img_url = $(this).data('file-url');

        if (img_url.indexOf('no-image') == -1) {
            var image = "<img src=" + img_url + " class='grid-view-item__image lazyload'>";
            var main_img = $(this).parents('.product-block').find('.card-thumbnail .image-secondary');
            main_img.empty().append(image);
            console.log(main_img);
        }
    })
})
$(document).find('#wishlist_add_product_btn').on('click', function () {
    var $this = $(this);
    let product_id = $this.data('product-id');
    let variant_id = $(document).find('select[name="id"] option:selected').val();
    console.log(product_id, variant_id);
    Appmate.wk.addProduct(product_id, variant_id)
        .then(function () {
            console.log('Product added to wishlist.');
            $(document).find('#wishlist_remove_product_btn').prop('hidden', false);
            $this.prop('hidden', true);
        })
        .catch(console.error);
});
$(document).find('#wishlist_remove_product_btn').on('click', function () {

});
$(document).find('#apply_filter').on('click', function () {
    $('#filterDropdown').collapse('toggle');
})
// let img_galary = $(document).find(".product-detail .product-detail__showcase .carousel-cell img");
// let variant_select = $(document).find(".product-form__variants.no-js option:selected");
// for (let index = 0; index < variant_select.length; index++) {
//     const option = variant_select.eq(index);
//     let var_img_src = option.attr("data-img-url");
//      for (let j = 0; j < img_galary.length; j++) {
//          const element = img_galary.eq(j);
//          let img_src = element.attr('data-src');
//          if(var_img_src.includes(img_src)){
//             let top = element.offset().top;
//              $(window).scrollTop(top);
//          }

//      }
// }
// $(document).find(".product-form__variants.no-js").on("change", function(){
//     console.log($(this).find("option:selected"));
//     let selected_src = $(this).find("option:selected").data("img-url");
//     for (let j = 0; j < img_galary.length; j++) {
//         const element = img_galary.eq(j);
//         let height = parseInt(element.outerHeight());
//         let img_src = element.attr('data-src');
//         if(selected_src.includes(img_src)){
//             console.log(element);
//         //    let top = element.offset().top;
//         //    top = top + height;
//            console.log(top);
//             // $(window).scrollTop(top);

//             $('html, body').animate({
//                 scrollTop: $(element).offset().top - 140
//             }, 500);
//         }           
//     }
// })